export const BREADCRUMBS_COLLAPSED_BUTTON_STRING_CONTENT = '...'
